var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-footer',[_c('a-row',{attrs:{"type":"flex"}},[_c('a-col',{attrs:{"span":24,"md":12}},[_c('p',{staticClass:"copyright"},[_vm._v(" © 2021, Silabu Inc. ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }